<template>
  <div class="login">
    <div
      class="background"
      :style="'background-image: url(/static/' + backgroundData.src + ')'"
    >
      <div class="overlay">
        <p>
          <a :href="backgroundData.url">
            {{ backgroundData.by }}
          </a>
        </p>
      </div>
    </div>
    <div class="form">
      <form @submit.prevent="login">
        <p style="text-align: center">
          <img
            src="https://app.restoku.id/assets/images/brand-color.png"
            alt="Restoku"
            width="250px"
          />
        </p>
        <div class="form-group">
          <label for="">Email</label>
          <input type="email" v-model="user.email" />
        </div>
        <div class="form-group">
          <label for="">Password</label>
          <input type="password" v-model="user.password" />
        </div>
        <div class="form-group">
          <button type="submit" class="btn-fill" :disabled="loading">
            <div class="loader" v-show="loading"></div>
            <span v-show="!loading">Login</span>
          </button>
        </div>
        <p>
          <a href="">Lupa Password?</a>
        </p>
      </form>
    </div>
  </div>
</template>

<script>
import * as api from "./../api/Api";

export default {
  name: "Login",
  components: {},
  data() {
    return {
      backgroundData: {},
      user: {},
      loading: false,
      credits: [
        {
          src: "pexels-life-of-pix-67468.jpg",
          by: "Photo by Life Of Pix from Pexels",
          url: "https://www.pexels.com/photo/clear-wine-glass-on-table-67468/",
        },
        {
          src: "pexels-michael-burrows-7125626.jpg",
          by: "Photo by Michael Burrows from Pexels",
          url: "https://www.pexels.com/photo/unrecognizable-male-barista-pouring-freshly-brewed-coffee-into-glass-pot-7125626/",
        },
      ],
      aksesMenu: [],
    };
  },
  methods: {
    getBackground() {
      var theRandomNumber = Math.floor(Math.random() * 2);
      return this.credits[theRandomNumber];
    },
    login() {
      if (!this.user.email && !this.user.password) {
        this.$toast("Email sama passwordnya jangan lupa diinput dulu ya");
        return;
      }
      if (!this.user.email) {
        this.$toast("Email jangan lupa diinput dulu ya");
        return;
      }
      if (!this.user.password) {
        this.$toast("Passwordnya juga diinput ya");
        return;
      }

      this.loading = true;
      api
        .post("/v4/login", this.user)
        .then((r) => {
          this.loading = false;
          if (!r.valid) {
            this.$toast(r.message);
          } else {
            const param = {
              isLogin: true,
              user: r.data.user,
              toko: r.data.toko,
            };

            this.$store.commit("settings/setLogin", param);

            this.loadAksesMenu(param.user.id_hak_akses);
          }
        })
        .catch((e) => {
          this.$toast("Server lagi bermasalah, coba bentar lagi ya");
          this.loading = false;
        });
    },
    loadAksesMenu(id_hak_akses) {
      api
        .get(
          "/v4/setting/user-akses?id=" +
            id_hak_akses +
            "&id_toko=" +
            this.$toko.id
        )
        .then((r) => {
          this.loading = false;
          const menu = r.data.detail;

          const menuParent = menu.filter((k) => {
            return k.id_parent == null;
          });

          menuParent.forEach((item) => {
            const menuChildren = menu.filter((k) => {
              return k.id_parent == item.id_menu;
            });

            if (menuChildren.length > 0) {
              item.hasChildren = true;
              item.open = true;
            }
            this.aksesMenu.push(item);

            menuChildren.forEach((child) => {
              this.aksesMenu.push(child);
            });
          });

          this.$store.commit("aksesMenu/save", this.aksesMenu);

          location.href = "/";
        })
        .catch((e) => {
          this.loading = false;
          this.$toast("Gagal mengambil data");
        });
    },
  },
  mounted() {
    this.backgroundData = this.getBackground();
  },
};
</script>

<style scoped lang="scss">
.login {
  display: grid;
  grid-template-columns: 1fr 600px;
  .background {
    position: relative;
    width: 100%;
    height: 100vh;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;

    .overlay {
      position: absolute;
      bottom: 30px;
      left: 60px;

      p {
        a {
          color: #fff;
          text-decoration: none;
          text-shadow: 1px 1px 2px #333;
        }
      }
    }
  }

  .form {
    display: flex;
    justify-content: center;
    align-items: center;

    form {
      width: 400px;
      h1 {
        color: var(--primary);
      }
    }
  }

  .form-group {
    margin-bottom: 15px;
    label {
      display: block;
      margin-bottom: 5px;
    }
  }

  input,
  select,
  textarea {
    background: #fff;
    border: 1px solid #ccc;
    outline: none;
    padding: 10px 6px;
    border-radius: 6px;
    width: 100%;

    &:focus {
      border: 1px solid var(--primary);
    }
  }

  input,
  textarea {
    padding: 12px 10px;
    width: calc(100% - 20px);
  }
  input[type="date"] {
    padding: 9px 10px;
  }

  button {
    cursor: pointer;
  }

  .btn-fill {
    background: var(--primary);
    border: 1px solid var(--primary);
    color: #fff;
    padding: 15px 20px;
    border-radius: 6px;
    width: 100%;
    text-align: center;
    font-weight: 700;
    text-transform: uppercase;
    outline: none;
    transition: all 0.3s ease;
    display: flex;
    justify-content: center;
    &:active {
      transform: scale(0.8);
      // background: var(--primary-darker);
    }
    &:disabled {
      background: var(--primary-disabled);
    }
  }

  p {
    text-align: center;
    a {
      color: var(--primary);
      text-decoration: none;
    }
  }

  .loader {
    border: 3px solid #f3f3f3; /* Light grey */
    border-top: 3px solid #3498db; /* Blue */
    border-radius: 50%;
    width: 20px;
    height: 20px;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue